export default __webpack_public_path__ + "static/media/home_img.d3372118.svg";